(function () {
  if (window.__cartCountSync) return;
  window.__cartCountSync = true;

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;

  function render(cart) {
    // Total units. For distinct products use cart.items.length instead.
    var count = cart.item_count;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  // fetch
  var _fetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = typeof a === 'string' ? a : (a && a.url) || '';
    var p = _fetch.apply(this, arguments);
    if (CART_URL.test(url)) p.then(refresh, function () {});
    return p;
  };

  // XMLHttpRequest
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(url || '')) this.addEventListener('load', refresh);
    return _open.apply(this, arguments);
  };

  // jQuery ajax
  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (e, xhr, settings) {
      if (settings && CART_URL.test(settings.url || '')) refresh();
    });
  }

  // Safety net: drawer product list re-rendered
  function watchDrawer() {
    var target = document.querySelector('#CartDrawer [data-products]');
    if (!target) return false;
    new MutationObserver(refresh).observe(target, { childList: true, subtree: true });
    return true;
  }
  if (!watchDrawer()) document.addEventListener('DOMContentLoaded', watchDrawer);

  // Back/forward cache and tab return
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  // Initial sync
  refresh();
})();